
import Vue, { PropType } from "vue";
import { FailureAlertSetting } from "@/models";

export default Vue.extend({
  name: "FailureAlertSettingEditor",

  props: {
    alertSetting: Object as PropType<FailureAlertSetting>,
  },
});
